import { z } from 'zod';
import { InspectionCornSchema, InspectionEntityCornSchema } from '../base.js';
export const InspectionTranscriptIndexCreatedSchema = z.object({
    artifactBucket: z.string(),
    artifactKey: z.string(),
    entityId: InspectionEntityCornSchema,
    inspectionId: InspectionCornSchema,
});
